// Library import
import {useEffect, useState} from 'react';
import {Alert, Modal} from 'react-bootstrap';
import Proptypes from 'prop-types';

// File Import
import CrossIcon from '~/images/icon/cross-gray.png';
import TrashIcon from '~/images/icon/trash.png';
import {UserApi} from '@/http/user';

// Components Import
import {Loading} from '@/components';

export const DeleteUserModal = ({show, userId, handleClose}) => {
    const [serverError, setServerError] = useState('');
    const [loading, setLoading] = useState(false);
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

    //   Delete user handle
    const handleDeleteUser = async (event) => {
        event.preventDefault();

        try {
            setLoading(true);
            setDisableSubmitBtn(true);
            const response = await UserApi.deleteUser(userId);

            if (response.status === 200) {
                setLoading(false);
                setDisableSubmitBtn(true);
                setTimeout(() => {
                    window.open('/admin/users', '_self');
                }, 1000);
            }
        } catch (error) {
            setLoading(false);
            setDisableSubmitBtn(false);
            setServerError('Server error occured !');
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered animation={true} className='modal-wrapper' backdrop='static'>
            <div className='p-5'>
                <div className='modal-common-content text-center'>
                    <img src={TrashIcon} alt='Trash icon'/>
                    <p className='text my-4'>アカウントを削除します。 宜しいですか ?</p>

                    <div className='action-btn d-flex justify-content-center align-items-center'>
                        <button className='button primary' disabled={disableSubmitBtn}
                                onClick={(event) => handleDeleteUser(event)}>
                            削除
                        </button>
                        <button className='button outline' onClick={handleClose}>
                            キャンセル
                        </button>
                    </div>
                </div>

                {/* Server error */}
                {serverError && <Alert variant='danger'>{serverError}</Alert>}

                {/* Loading */}
                {loading && <Loading/>}

                <div className='close-modal' onClick={handleClose}>
                    <img src={CrossIcon} alt='Cross icon'/>
                </div>
            </div>
        </Modal>
    );
};

DeleteUserModal.prototype = {
    show: Proptypes.bool,
    handleClose: Proptypes.func,
    userId: Proptypes.number
};
